<template>

<div>
<div class="login_wrap">
    
    <dl>
        <dt>비밀번호 재설정</dt>
        <dd>
            새로운 비밀번호를 설정해주세요.
        </dd>
    </dl>

    <ul class="login_form">
        <li>
            <input type="password" placeholder="비밀번호 입력" v-model="password">
            <p class="new_password">영문, 숫자 조합 8자리 이상</p>
        </li>
        <li>
            <input type="password" placeholder="비밀번호 확인" v-model="passwordChk">
        </li>
    </ul>

    <div class="btn_box_fixed">
        <a class="default_btn1" @click="validate">비밀번호 설정 완료</a>
    </div> 
</div>
</div>
</template>

<script>
import $ from 'jquery';
import { mapState } from 'vuex';
import { PasswordMixin } from '../../../mixins/PasswordMixin';

export default {
    name:'PasswordChange',
    mixins:[PasswordMixin],

    created() {
        this.$store.commit('SHOW_ONLOAD');
    },

    mounted () {
        $('.login_wrap input').focus(function(){
            setTimeout(function () {
                $(".btn_box_fixed").css({"position":"unset","transform":"unset","width":"100%"});
            }, 100);
            
        });

        $('.login_wrap input').blur(function(){
            setTimeout(function () {
                $(".btn_box_fixed").css({"position":"fixed","transform":"translateX(-50%)","width":"100%"});
            }, 100);
        });
    },

    beforeRouteEnter(to, from, next) {
        if(from.name != 'PwNiceAuth') next('/main');
        next();
    },

    data() {
        return {
            password: '',
            passwordChk: '',
        }
    },
    computed: {
        ...mapState({
            authWrite: state => state.auth.itemWrite,
        })
    },
    methods: {
        validate() 
        {
            try 
            {
                if (!this.password) throw '비밀번호를 입력해주세요.';
                
                let pwChk = this.chkPassword(this.password);

                if (pwChk) throw pwChk;

                if (!this.passwordChk) throw '비밀번호 확인을 입력해주세요.';
                if (this.password != this.passwordChk) throw '비밀번호가 일치하지 않습니다.';
            } 
            catch (error) 
            {
                this.$store.commit('OPEN_MODAL', {
                    content:error,
                    btnOne:'확인',
                })
                return;
            }
            
            this.submit();
        },

        submit(){
            this.authWrite.password = this.password;
            this.$store.dispatch('CHANGE_USER_PW', this.authWrite)
            .then(()=>{
                this.$store.commit('OPEN_MODAL', {
                    content: '비밀번호 변경이 완료되었습니다.',
                    btnOne:'확인',
                    btnOneSubmit: () => {
                        this.$router.go(-2);
                    }
                })
            });
            
        }
    },

}
</script>

<style lang="scss" scoped>

</style>